import { MessageAuthorType, MessageVisibility, type SocketComment } from '@21k/shared';

import type { Comment } from '../api/types';

export function socketCommentToComment(comment: SocketComment): Comment {
  const nameParts = comment.senderName.trim().split(/\s+/);

  return {
    id: comment.id,
    ticketId: comment.ticketId,
    authorId: comment.authorId,
    parentId: null,
    content: comment.content,
    authorType: comment.authorType as MessageAuthorType,
    visibility: comment.visibility as MessageVisibility,
    sentViaChannel: comment.sentViaChannel,
    createdAt: comment.createdAt,
    parentAuthorName: comment.parentAuthorName,
    author:
      comment.authorType === 'AGENT' && comment.authorId
        ? {
            id: comment.authorId,
            firstName: nameParts[0] ?? comment.senderName,
            lastName: nameParts.slice(1).join(' '),
            email: '',
          }
        : null,
    assets: comment.assets.map((asset) => ({
      id: asset.id,
      ticketId: comment.ticketId,
      commentId: comment.id,
      fileName: asset.fileName,
      mimeType: asset.mimeType,
      sizeBytes: asset.sizeBytes,
      s3Key: '',
      createdAt: comment.createdAt,
      uploadedBy: null,
    })),
    isVisibleToCustomer: comment.visibility === 'CUSTOMER_VISIBLE',
    isSystemEvent: comment.isSystemEvent,
  };
}
